import React from "react";
import LegalPage from "../components/LegalPage";

export default function Termos() {
  return (
    <LegalPage title="Termos de utilização">
      <h2>Âmbito</h2>
      <p>
        Estes termos regulam a utilização do website, formulários e conteúdos
        disponibilizados pelo CENFOTEP.
      </p>
      <h2>Informação e pedidos</h2>
      <p>
        O utilizador compromete-se a fornecer dados correctos. Um pedido enviado
        pelo website não constitui confirmação automática de inscrição, reserva
        ou contratação.
      </p>
      <h2>Propriedade intelectual</h2>
      <p>
        Textos, identidade visual, materiais pedagógicos e outros conteúdos
        pertencem ao CENFOTEP ou aos respectivos titulares e não devem ser
        reproduzidos sem autorização.
      </p>
      <h2>Responsabilidade</h2>
      <p>
        Trabalhamos para manter a informação actualizada, mas datas, preços e
        disponibilidade devem ser confirmados com a equipa.
      </p>
    </LegalPage>
  );
}
